<template>
  <div
    class="points-card"
  >
    <div
      class="points-card__info"
    >
      <dl
        class="points-card__list"
      >
        <dt class="points-card__item-label">
          {{ wordings.rewardpoints }} :
        </dt>
        <dd class="points-card__item-val">
          {{ formatNumberDisplayByLang(rewardPoints) }}
        </dd>
      </dl>
      <dl
        class="points-card__list"
      >
        <dt class="points-card__item-label">
          {{ wordings.statuspoints }} :
        </dt>
        <dd class="points-card__item-val">
          {{ formatNumberDisplayByLang(statusPoints) }}
        </dd>
      </dl>
      <dl
        class="points-card__list"
      >
        <dt class="points-card__item-label">
          {{ wordings.nights }} :
        </dt>
        <dd class="points-card__item-val">
          {{ formatNumberDisplayByLang(nights) }}
        </dd>
      </dl>
    </div>
  </div>
</template>
<script lang="es" src="./PointsCard.es"></script>
<style lang="scss" src='./PointsCard.scss' scoped></style>
